<div class="container px-8">
    <app-title title="Update Organization"></app-title>
    <div class="border-solid border-gray-200 border rounded-3xl px-16 py-8 ">
        <h3 class="text-primary poppins-medium mb-12">Organization Information</h3>
        <form [formGroup]="updateOrganizationForm">
            <section class="grid grid-cols-2 gap-8">
                <section class="flex flex-col gap-2">
                    <label for="name">Name
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="name" [required]="true" />
                    <small class="text-red-500"
                        *ngIf="updateOrganizationForm.get('name')?.touched && updateOrganizationForm.get('name')?.hasError('required')">
                        Organization Name is required.
                    </small>
                </section>
                <section class="flex flex-col gap-2">
                    <label for="code">Code
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="code" [required]="true" />
                    <small class="text-red-500"
                        *ngIf="updateOrganizationForm.get('code')?.touched && updateOrganizationForm.get('code')?.hasError('required')">
                        Organization Code is required.
                    </small>
                </section>


                <section class="flex flex-col gap-2">
                    <label for="adminEmail">Admin Email
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="adminEmail" [required]="true" />
                    <small class="text-red-500"
                        *ngIf="updateOrganizationForm.get('adminEmail')?.touched && (updateOrganizationForm.get('adminEmail')?.hasError('adminEmail') || updateOrganizationForm.get('adminEmail')?.hasError('required'))">
                        Please enter a valid email.
                    </small>
                </section>


                <section class="flex flex-col gap-2">
                    <label for="adminPhone">Admin Phone</label>
                    <p-inputGroup>
                        <p-inputGroupAddon>+91</p-inputGroupAddon>
                        <input type="tel" pInputText placeholder="" formControlName="adminPhone" maxlength="10" />
                    </p-inputGroup>

                </section>

                <section  class="flex flex-col gap-2">
                    <label for="credits">Credits
                    </label>
                    <input type="number" pInputText placeholder="" formControlName="credits" />
                </section>

                <section class="flex flex-col gap-2">
                    <label for="orgStatus">Org Status
                    </label>
                    <p-dropdown styleClass="!w-full" formControlName="orgStatus" [options]="orgStatusOptions" />
                </section>
                <section class="flex flex-col gap-2">
                    <label for="gender">GSTIN Number
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="gstInNumber" [maxlength]="15" [required]="true" />
                    <small *ngIf="checkErrorMessage(updateOrganizationForm, 'gstInNumber', isSubmitted())" class="text-red-500 text-sm mt-1">
                        GST Number is required</small>
                </section>
            </section>
            <div class="card flex justify-end mt-6">
                <p-button label="Submit" (onClick)="updateOrg()" />
            </div>
        </form>
    </div>
</div>

